import React from "react"
import { EnderecosBloqueadosContextProvider } from "./context/EnderecosBloqueadosContextProvider"
import { EnderecosBloqueados } from "./EnderecosBloqueados"

export function Index() {
    return (
        <EnderecosBloqueadosContextProvider>
            <EnderecosBloqueados />
        </EnderecosBloqueadosContextProvider>
    )
}
